import { Col } from "@commonlibs";
import styled, { css } from "styled-components";
import { MultipleImageUploadWrapperProps } from "./ImageUpload.types";

export const MultipleImageUploadWrapper = styled(Col)<MultipleImageUploadWrapperProps>(
    ({ theme, fullWidth }) => css`
        row-gap: ${theme.spacing["4"]};
        width: ${fullWidth ? "100%" : "auto"};
    `,
);
